import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';

// Redux 

import { useTranslation } from 'react-i18next';
import { setDeletedAccountId, setIsRefreshDoctorsList, setSelectedDoctor } from '../../../../redux/features/hacker/users/doctorsAccess';
import { setNotificationMessage } from '../../../../redux/features/general/notification';
import { setOpenPopup } from '../../../../redux/features/general/popup';

// Routes

// Icons 

import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import InfoRow from '../../../general/inputs/InfoRow';
import RecommendOutlinedIcon from '@mui/icons-material/RecommendOutlined';
import { updateGroupAccess } from '../../../../routes/doctor/account';
import { setIsRefreshGroupAccessList, setSelectedGroupAccess } from '../../../../redux/features/doctor/group/groupAccess';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import { setIsRefreshSubscription } from '../../../../redux/features/doctor/billing/billing';

type Props = {
  positionX: number,
  positionY: number,
};


const Dropdown: React.FC<Props> = ({ positionX, positionY }) => {

    const { t } = useTranslation(); 

    const dispatch = useAppDispatch(); 

    const colors = useAppSelector(state => state.theme.colors); 

    const selectedGroupAccess = useAppSelector(state => state.groupAccess.selectedGroupAccess);  
    const group = useAppSelector(state => state.billing.group); 
    const activeCount = useAppSelector(state => state.billing.activeCount);  

    // -- 

    const handleDoctorDeactivation = async () => { 

        const config = { 
            groupAccessId: selectedGroupAccess._id,
            status: 'inactive'
        }; 

        const res = await updateGroupAccess(config); 

        if (res?.data.status === 200) { 

            handleRefresh(); 

            dispatch(setNotificationMessage(t('groupAccessDeactivated'))); 

        }; 

    }; 

    // -- 

    const handleDoctorReactivation = async () => { 

        const config = { 
            groupAccessId: selectedGroupAccess._id,
            status: 'active'
        }; 

        const res = await updateGroupAccess(config); 

        if (res?.data.status === 200) { 

            handleRefresh(); 

            dispatch(setNotificationMessage(t('groupAccessReactivated'))); 

        }; 

    }; 

    // -- 

    const handleInvite = async () => { 

        const config = { 
            groupAccessId: selectedGroupAccess._id,
            isDeleteGroupAccess: true, 
        }; 

        const res = await updateGroupAccess(config); 

        if (res?.data.status === 200) { 

            handleRefresh(); 

            dispatch(setNotificationMessage(t('inviteRemoved'))); 

        }; 

    }; 

    // -- 

    const handleRefresh = () => { 

        dispatch(setIsRefreshSubscription(true)); 
        dispatch(setIsRefreshGroupAccessList(true)); 
        dispatch(setSelectedGroupAccess(null));

    }; 

    // -- 
    
    return (

        <Box
            sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                width: 200,
                left: positionX - 250, 
                top: positionY, 
                position: 'absolute',
                backgroundColor: colors?.dropdown,
                borderRadius: 2,
                cursor: 'pointer',
                zIndex: 5, 
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
            }}
        >

            {(selectedGroupAccess?.status == 'active') && 
            <InfoRow
                icon={<NoAccountsIcon sx={{ color: colors?.text }} />}
                title='deactivate'
                titleStyle={{ marginLeft: 2 }}
                handler={handleDoctorDeactivation}
                extraStyle={{ 
                    width: '100%',
                    borderRadius: 1, 
                    '&:hover': { 
                        backgroundColor: colors?.sectionHover 
                    }
                }}
            />}

            {((selectedGroupAccess?.status != 'active') && (group?.seats > activeCount)) &&  
            <InfoRow
                icon={<RecommendOutlinedIcon sx={{ color: colors?.text }} />}
                title='reactivate'
                titleStyle={{ marginLeft: 2 }}
                handler={handleDoctorReactivation}
                extraStyle={{ 
                    width: '100%',
                    borderRadius: 1, 
                    '&:hover': { 
                        backgroundColor: colors?.sectionHover 
                    }
                }}
            />}

            {(selectedGroupAccess?.status == 'pending') &&  
            <InfoRow
                icon={<RemoveCircleOutlineOutlinedIcon sx={{ color: colors?.text }} />}
                title='removeInvite'
                titleStyle={{ marginLeft: 2 }}
                handler={handleInvite}
                extraStyle={{ 
                    width: '100%',
                    borderRadius: 1, 
                    '&:hover': { 
                        backgroundColor: colors?.sectionHover 
                    }
                }}
            />}

        </Box>

    ); 

};

export default Dropdown;